module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_8011.d223a8db.png";